export function ToId(input: any) {
  return (!isNaN(+input) && typeof +input) == 'number' ? input : 'uid_' + input;
}
